import { IActionContext } from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { createCanonicalUrl } from './utilities/createCanonicalUrl';

export const getProductVariantUrl = (productDetails: SimpleProduct, context: IActionContext) => {
    const title = productDetails.Name ?? '';
    let normalizedCanonicalUrl = createCanonicalUrl(
        context,
        [title ?? ''],
        `${productDetails.MasterProductId ?? productDetails.RecordId}.p`
    ).toLowerCase();

    const dimParams = productDetails.Dimensions?.map(dim => {
        if (dim.DimensionTypeValue === 1 && dim.DimensionValue?.Value) {
            return `color=${encodeURIComponent(dim.DimensionValue.Value).replace(/%20/g, '+')}`;
        }

        if (dim.DimensionTypeValue === 3 && dim.DimensionValue?.Value) {
            return `size=${encodeURIComponent(dim.DimensionValue.Value).replace(/%20/g, '+')}`;
        }

        if (dim.DimensionTypeValue === 4 && dim.DimensionValue?.Value) {
            return `style=${encodeURIComponent(dim.DimensionValue.Value).replace(/%20/g, '+')}`;
        }

        return null;
    })
        .filter(p => !!p)
        .join('&');

    if (dimParams) {
        normalizedCanonicalUrl = `${normalizedCanonicalUrl}?${dimParams}`;
    }

    return normalizedCanonicalUrl;
};
